import React from 'react';
import PropTypes from 'prop-types';
import CorrectIcon from '@learningblocks/exp-constants/lib/Images/correct-icon.svg';
import IncorrectIcon from '@learningblocks/exp-constants/lib/Images/incorrect-icon.svg';
import {Tooltip, Image} from '@learningblocks/storybook-components';

/**
 * Feedback: Icon component that display correct
 *           incorrect icon based on Dropped Node option
 *           When Incorrect Component also display a tooltip
 *           Message.
 */
export function Feedback({correct, message}) {
  const tooltipMessage = correct ? '' : message;
  const icon = correct ? CorrectIcon : IncorrectIcon;
  return (
    <Tooltip title={tooltipMessage}>
      <Image src={icon} alt={message} />
    </Tooltip>
  );
}

Feedback.propTypes = {
  /**
   * Boolean specifying if Option is Correct/Incorrect
   */
  correct: PropTypes.bool.isRequired,
  /**
   * Message to be displayed on error-tooltip
   */
  message: PropTypes.string.isRequired,
};

Feedback.defaultProps = {
  correct: false,
  message: `incorrect`,
};
